import { createApp, provide, h } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'

// HTTP connection to the API
const httpLink = createHttpLink({
  // You should use an absolute URL here
  //uri: 'http://217.154.195.39:3000/api/graphql',
  uri:'https://cms.teammisfit.pl/api/graphql'
})

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
const apolloClient = new ApolloClient({
  link: httpLink,
  cache,
})
import { DefaultApolloClient } from '@vue/apollo-composable'

const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient)
  },

  render: () => h(App),
})

app.use(store).use(router).mount('#app')
